import { render, staticRenderFns } from "./PageMobile.vue?vue&type=template&id=3bf5d2e0"
import script from "./PageMobile.vue?vue&type=script&lang=js"
export * from "./PageMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports